import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSchool } from '../context/SchoolContext';
import { unlockCrossSchoolAccess } from '../api/axios';

export const CrossSchoolAccessPage: React.FC = () => {
  const { refreshCrossSchoolStatus, crossSchoolUnlocked, crossSchoolExpiresAt } = useSchool();
  const [key, setKey] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setBusy(true);
    try {
      const res = await unlockCrossSchoolAccess(key);
      setMessage(res.message ?? 'Cross-school access granted.');
      setKey('');
      await refreshCrossSchoolStatus();
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ??
        'Unlock failed. Check the key and try again.';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '48px auto', padding: '0 16px', fontFamily: 'system-ui, sans-serif' }}>
      <p>
        <Link to="/admin">← Back to admin dashboard</Link>
      </p>
      <h1 style={{ fontSize: '1.35rem' }}>Cross-school administrator access</h1>
      <p style={{ color: '#444', lineHeight: 1.5 }}>
        Your account is normally limited to your home school. Enter the server-configured administrator key to
        start a time-limited session that allows the other school&apos;s data where the system supports it (same
        as fee unlock: separate keys).
      </p>
      {crossSchoolUnlocked ? (
        <p style={{ color: '#166534', fontWeight: 600 }}>
          Session active
          {crossSchoolExpiresAt ? ` — expires ${new Date(crossSchoolExpiresAt).toLocaleString()}` : ''}.
        </p>
      ) : (
        <p style={{ color: '#92400e' }}>No active cross-school session.</p>
      )}
      <form onSubmit={onSubmit} style={{ marginTop: 24 }}>
        <label htmlFor="unlock-key" style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
          Administrator key
        </label>
        <input
          id="unlock-key"
          type="password"
          autoComplete="off"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          style={{ width: '100%', padding: '10px 12px', fontSize: '1rem', boxSizing: 'border-box' }}
          placeholder="Enter key from server configuration"
        />
        <button
          type="submit"
          disabled={busy || !key.trim()}
          style={{
            marginTop: 16,
            padding: '10px 20px',
            fontSize: '1rem',
            cursor: busy ? 'wait' : 'pointer',
            background: '#1e3a5f',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
          }}
        >
          {busy ? 'Checking…' : 'Unlock'}
        </button>
      </form>
      {message && <p style={{ color: '#166534', marginTop: 16 }}>{message}</p>}
      {error && <p style={{ color: '#b91c1c', marginTop: 16 }}>{error}</p>}
    </div>
  );
};
